"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationTheft = function IllustrationTheft() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "67",
    height: "65",
    fill: "none",
    viewBox: "0 0 67 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    x: "1.263",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#D5CCDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M1 58h65"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M50.325 26.369c-1.72 1.602-3.861 2.062-4.941 1.016-1.08-1.046-1.026-3.684.177-5.777.28-.435.64-.801 1.053-1.078a3.344 3.344 0 011.355-.529c.479-.073.966-.037 1.43.106.466.143.898.39 1.272.724 1.755 1.607 1.001 4.29-.346 5.538zM29.064 47.41l-5.816-.128a1.394 1.394 0 00-.955.37 1.69 1.69 0 00-.517.966c-.037.229-.03.463.021.69.05.226.142.438.27.623.128.186.29.34.473.452.184.112.386.181.594.202l7.851.713L36.283 46l-4.554-2.21-2.665 3.62z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeWidth: "1.5",
    d: "M52.88 39h-3.064c-1.053 1.65-2.553 4.4-2.553 6.967 0 2.933 2.639 4.033 4 4.033 1.362 0 4-1.1 4-4.033 0-2.567-1.588-5.44-2.383-6.967z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M41.008 49.24l.22 6.42c.016.385.154.75.39 1.032.235.282.554.465.902.515.208.027.42.005.622-.063.201-.069.388-.182.548-.334.16-.152.29-.338.38-.547.092-.21.142-.436.15-.667l.192-8.7-5.133-5.213 3.402-5.348.797 1.335c.16.272.373.5.624.67.25.17.533.276.827.312 1.246.153 5.093.509 7.003.683.146.012.293-.008.433-.059.14-.05.269-.131.38-.237a1.23 1.23 0 00.27-.378c.068-.144.108-.3.12-.461a1.3 1.3 0 00-.175-.792 1.105 1.105 0 00-.593-.486c-1.505-.515-4.63-1.599-6.309-2.334a11.413 11.413 0 00-1.667-4.059 10.263 10.263 0 00-3.008-2.979c-.438-.3-.95-.444-1.469-.411l-11.962.636c-.34.016-.67.126-.963.32a2.161 2.161 0 00-.707.79l-2.403 4.514a1.189 1.189 0 00-.103.844c.034.14.094.272.175.387.081.114.183.21.298.28l.851.513c.212.131.46.172.7.117.238-.055.452-.204.6-.418l2.723-3.936 8.068.112-3.314 3.385-1.79 3.577c-.839 1.66-.931 4.05-.2 5.518 1.205.67 2.753 1.097 4.557 2.206l4.564 3.255z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M14.013 28.25L20.513 28.25"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M14.013 41.25L20.513 41.25"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.013 34.25L16.513 34.25"
  }));
};

var _default = IllustrationTheft;
exports.default = _default;